import { Routes } from '@angular/router';
import { ProviderPeerComparisonsComponent } from './pages/provider-peer-comparisons/provider-peer-comparisons.component';
import {
  AppLayout,
  AuthGuard,
  CaseAccessGuard,
  RoleGuard,
  AccountAccessGuard,
  Roles,
} from 'shared-library';
import { ProviderUtilizationComponent } from './pages/provider-utilization/provider-utilization.component';

export const routes: Routes = [
  {
    path: '',
    component: AppLayout,
    children: [
      {
        path: '',
        redirectTo: '/provider-utilization',
        pathMatch: 'full',
      },
      {
        path: 'provider-utilization',
        canActivate: [RoleGuard, AuthGuard],
        data: { role: [Roles.Administrator, Roles.CaseManager] },
        component: ProviderUtilizationComponent,
      },
      {
        path: 'network-analysis',
        // canActivate: [RoleGuard, AuthGuard],
        // data: { role: [Roles.Administrator, Roles.CaseManager] },
        loadComponent: () =>
          import('./pages/network-analysis/network-analysis.component').then(
            (m) => m.NetworkAnalysisComponent
          ),
      },
      {
        path: 'provider-peer-comparisons',
        canActivate: [RoleGuard, AuthGuard],
        data: { role: [Roles.Administrator, Roles.CaseManager] },
        component: ProviderPeerComparisonsComponent,
      },
      {
        path: 'case-table',
        canActivate: [AuthGuard],
        data: {
          role: [Roles.Administrator, Roles.CaseManager, Roles.Investigator],
        },
        loadComponent: () =>
          import('./pages/case-table/case-table.component').then(
            (m) => m.CaseTableComponent
          ),
      },

      {
        path: 'case-detail/:id',
        canActivate: [RoleGuard, AuthGuard, CaseAccessGuard],
        data: {
          role: [Roles.Administrator, Roles.CaseManager, Roles.Investigator],
        },
        loadComponent: () =>
          import('./pages/case-detail/case-detail.component').then(
            (m) => m.CaseDetailComponent
          ),
      },

      {
        path: 'hospital-admissions',
        canActivate: [AuthGuard],
        data: {
          role: [Roles.Administrator, Roles.CaseManager, Roles.Investigator],
        },
        loadComponent: () =>
          import('./pages/admissions-table/admissions-table.component').then(
            (m) => m.AdmissionsTableComponent
          ),
      },

      {
        path: 'admissions-detail/:id',
        canActivate: [RoleGuard, AuthGuard, CaseAccessGuard],
        data: {
          role: [Roles.Administrator],
        },
        loadComponent: () =>
          import('./pages/admissions-detail/admissions-detail.component').then(
            (m) => m.AdmissionsDetailComponent
          ),
      },
      {
        path: 'reports',
        loadChildren: () =>
          import('./routes/report-routes').then((m) => m.reportRoutes),
      },

      {
        path: 'manage-users',
        canActivate: [RoleGuard, AuthGuard],
        data: { role: Roles.Administrator },
        loadComponent: () =>
          import('shared-library').then((m) => m.ManageUsersComponent),
      },
      {
        path: 'create-user',
        resolve: [RoleGuard],
        canActivate: [AuthGuard],
        data: { role: Roles.Administrator },
        loadComponent: () =>
          import('shared-library').then((m) => m.AddUserComponent),
      },

      {
        path: 'user-details/:id',
        canActivate: [AuthGuard, AccountAccessGuard],
        loadComponent: () =>
          import('shared-library').then((m) => m.UserDetailsComponent),
      },
      {
        path: 'about-page',
        outlet: 'modal',
        loadComponent: () =>
          import('shared-library').then((m) => m.AboutPageComponent),
      },
    ],
  },
  {
    path: 'auth',
    loadChildren: () => import('shared-library').then((m) => m.AUTH_ROUTES),
  },
  {
    path: 'error',
    loadChildren: () => import('shared-library').then((m) => m.ERROR_ROUTES),
  },
  {
    path: '**',
    redirectTo: 'error/404',
  },
];
